
import { Component, Vue, Prop } from 'vue-property-decorator'
import FetchWrapper from '@/classes/fetchWrapper'

const CreateUpdateApiModalProps = Vue.extend({
  props: {
    canCancel: Boolean,
    close: Boolean,
    isCreate: Boolean,
    idx: Number,
    externalKey: String,
    userId: Number,
    externalType: String// 's2t' || 't2t'
  }
})

Vue.prototype.$multiwatch = function (props, watcher) {
  var iterator = function (prop) {
    this.$watch(prop, watcher)
  }
  props.forEach(iterator, this)
}

@Component
export default class CreateUpdateApiModal extends CreateUpdateApiModalProps {
  data () {
    return {
      isLoading: false,
      selectedType: null,
      isFormValid: false,
      types: [
        {
          name: 'Speech to text',
          value: 'S2T'
        },
        {
          name: 'Text to text',
          value: 'T2T'
        }
      ],
      key: ''
    }
  }

  get isComponentModalActive () {
    return this.close
  }

  created () {
    this.$multiwatch(['selectedType', 'key'], function () {
      this.validateForm()
    })
    this.$multiwatch(['externalKey'], function () {
      this.key = this.externalKey
    })
    this.$multiwatch(['externalType'], function () {
      this.selectedType = this.externalType
    })
  }

  validateForm () {
    if (this.$refs.form) {
      this.isFormValid = this.$refs.form.checkValidity() && this.selectedType !== '' && this.key !== ''
    }
  }

  async createOrUpdateApi () {
    try {
      this.isLoading = true

      var resp
      var msg = 'Api Created Successfully'
      var data = {
        type: this.selectedType.toLowerCase(),
        userId: this.userId,
        key: this.key
      }
      if (this.isCreate) {
        resp = await FetchWrapper.post(`${process.env.VUE_APP_SERVERURL}/createApi`, data)
      } else {
        msg = 'Api Updated Successfully'
        data.idx = this.idx
        resp = await FetchWrapper.post(`${process.env.VUE_APP_SERVERURL}/updateApiKey`, data)
      }
      this.isLoading = false
      if (resp.error) {
        this.$buefy.dialog.confirm({
          title: 'Error',
          message: resp.error,
          canCancel: false
        })
      } else {
        this.$buefy.dialog.confirm({
          title: 'Success',
          message: msg,
          onConfirm: () => {
            if (this.isCreate) {
              this.$emit('created', resp.id)
            } else {
              this.$emit('updated', resp.id)
            }
            this.$emit('close')
            this.selectedType = null
            this.key = ''
            this.isFormValid = false
          },
          canCancel: false
        })
      }
    } catch (e) {
      this.isLoading = false
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: `Something went wrong. ${e}`,
        canCancel: false
      })
    }
  }
}
